/*
 * File: components/admin/LuongT13Management.js
 * Mô tả: Giao diện quản lý hoàn chỉnh với tra cứu nhanh.
 */
import React, { useState, useEffect } from 'react';
import { apiUploadLuongT13, apiAdminGetLuongT13ByYear } from '../../api';
import LuongT13Details from '../payroll/LuongT13Details';

export default function LuongT13ManagementComponent() {
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });
    const [uploadYear, setUploadYear] = useState(new Date().getFullYear());
    
    const [searchMsnv, setSearchMsnv] = useState('');
    const [previewData, setPreviewData] = useState(null);
    const [dataOfCurrentYear, setDataOfCurrentYear] = useState([]);

    // Tự động tải dữ liệu khi thay đổi năm
    useEffect(() => {
        const loadData = async () => {
            try {
                const result = await apiAdminGetLuongT13ByYear(uploadYear);
                setDataOfCurrentYear(result.data || []);
            } catch (error) {
                setDataOfCurrentYear([]);
            }
        };
        loadData();
        setPreviewData(null);
    }, [uploadYear]);

    const handleFileChange = (event) => { 
        setSelectedFile(event.target.files[0]); 
        setMessage({ type: '', text: '' }); 
    };

    const handleUpload = async () => {
        if (!selectedFile) return;
        setIsUploading(true);
        try {
            const result = await apiUploadLuongT13(selectedFile, uploadYear);
            setMessage({ type: 'success', text: result.message });
            if (result.data) setDataOfCurrentYear(result.data);
        } catch (error) {
            setMessage({ type: 'error', text: error.message });
        } finally {
            setIsUploading(false);
            setSelectedFile(null);
            if (document.getElementById('luong-t13-input')) document.getElementById('luong-t13-input').value = null;
        }
    };

    const handleSearch = () => {
        if (!searchMsnv) return;
        const emp = dataOfCurrentYear.find(item => 
            String(item.MSNV).trim().toUpperCase() === searchMsnv.trim().toUpperCase()
        );
        if (emp) {
            setPreviewData(emp);
        } else {
            setPreviewData(null);
            alert(`Không tìm thấy MSNV ${searchMsnv} trong năm ${uploadYear}`);
        }
    };

    const years = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i);

    return (
        <div className="p-4 space-y-6">
            {/* Box Upload */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                <h2 className="text-xl font-bold mb-4">Cập nhật Lương Tháng 13</h2>
                <div className="flex flex-wrap items-center gap-4 bg-gray-50 p-4 rounded-lg">
                    <select 
                        value={uploadYear} 
                        onChange={(e) => setUploadYear(parseInt(e.target.value))}
                        className="p-2 border rounded"
                    >
                        {years.map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                    <input id="luong-t13-input" type="file" onChange={handleFileChange} className="text-sm" />
                    <button 
                        onClick={handleUpload}
                        disabled={isUploading || !selectedFile}
                        className="bg-indigo-600 text-white px-6 py-2 rounded-lg font-bold disabled:bg-gray-400"
                    >
                        {isUploading ? 'Đang xử lý...' : 'Bắt đầu Upload'}
                    </button>
                </div>
                {message.text && <p className={`mt-2 font-medium ${message.type === 'error' ? 'text-red-500' : 'text-green-600'}`}>{message.text}</p>}
            </div>

            {/* Box Tra cứu */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                <h3 className="text-lg font-bold mb-4">Tra cứu nhanh phiếu của nhân viên ({uploadYear})</h3>
                <div className="flex gap-2 mb-6">
                    <input 
                        type="text" 
                        placeholder="Nhập mã nhân viên..." 
                        value={searchMsnv}
                        onChange={(e) => setSearchMsnv(e.target.value)}
                        className="border p-2 rounded w-64 outline-none focus:ring-2 focus:ring-amber-400"
                    />
                    <button onClick={handleSearch} className="bg-amber-500 text-white px-8 py-2 rounded-lg font-bold hover:bg-amber-600">
                        Xem phiếu
                    </button>
                </div>

                {previewData ? (
                    <div className="border-t pt-6">
                        <LuongT13Details data={previewData} year={uploadYear} />
                    </div>
                ) : (
                    <div className="py-10 text-center border-2 border-dotted border-gray-100 rounded-xl text-gray-400">
                        {dataOfCurrentYear.length > 0 ? `Hệ thống đã sẵn sàng ${dataOfCurrentYear.length} nhân viên. Nhập MSNV để xem.` : "Chưa có dữ liệu cho năm này."}
                    </div>
                )}
            </div>
        </div>
    );
}